import { model } from '../core/model'

const sendEvent = (event, data) => {
    if (model.Embed.Mobile) {
      
        var request = {
            event: event,
            data: data
        };
        console.log('AppEvent');
        console.log(request);
        try {
            webkit && webkit.messageHandlers.ios.postMessage(JSON.stringify(request));
        } catch (err) {
            console.error('Error IOs: ' + err.message);
        }
        try {
            android && android.performClick(JSON.stringify(request));
        } catch (err) {
            console.error('Error Android: ' + err.message);
        }
    }
};

module.exports = {
    sendEvent
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/appEvent.js